import { render } from "./searchTerpeneAroma.vue?vue&type=template&id=1dea2b58"
import script from "./searchTerpeneAroma.vue?vue&type=script&lang=js"
export * from "./searchTerpeneAroma.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__